import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';

import { BhDemoContentComponent } from './demo-content/demo-content.component';
import { BhDemoSidebarComponent } from './demo-sidebar/demo-sidebar.component';

@NgModule({
    declarations: [
        BhDemoContentComponent,
        BhDemoSidebarComponent
    ],
    imports     : [
        RouterModule,

        MatDividerModule,
        MatListModule
    ],
    exports     : [
        BhDemoContentComponent,
        BhDemoSidebarComponent
    ]
})
export class BhDemoModule
{
}
